import constant from './constant';

export const setSideNavItem = (item)=> ({
    type: constant.CHANGE_SIDE_ITEM,
    payload: item
});

export const cleanUpSideItem = ()=> ({
    type: constant.CLEAN_UP_ITEM,
});
